














































































































	import {Component, Vue} from '@/shared/component';
	import {Stored} from "vue-stored-prop-decorator/index";
	import {User, Tache, Projet, Client, Devis} from '@/models';
	import {Emit} from 'vue-property-decorator';
	
	import storeUser from '@/stores/modules/user';
	import { version } from '../../../package.json';
	import CrudTacheEditDialog from "@/components/Crud/Tache/EditDialog.vue";
	import CrudProjetEditDialog from "@/components/Crud/Projet/EditDialog.vue";
	import CrudClientEditDialog from "@/components/Crud/Client/EditDialog.vue";
	import CrudDevisEditDialog from "@/components/Crud/Devis/EditDialog.vue";

	@Component({
		components: {
			CrudTacheEditDialog,
			CrudProjetEditDialog,
			CrudClientEditDialog,
			CrudDevisEditDialog,
		}
	})

	export default class NavigationMainMenu extends Vue {

		@Stored(() => storeUser) me!: User;

		private reduce: boolean = false;
		private open: boolean = false;
		private appVersion = version;

		private items = [
			{
				route: { name: 'home' },
				title: 'Accueil',
				icon: 'mdi-home',
			},
			{
				title: 'Clients',
				icon: 'mdi-account-multiple',
				grant: 'NAV_CLIENT',
				children: [
					{
						route: { name: 'clients' },
						title: 'Liste des clients',
						icon: 'mdi-account-multiple',
						grant: 'API_GET_CLIENT',
					},
					{
						title: 'Créer un client',
						icon: 'mdi-account-plus',
						grant: 'API_POST_CLIENT',
						clickparameter: 'Client',
					},
				]
			},
			{
				title: 'Devis',
				icon: 'mdi-clipboard-text-multiple',
				grant: 'NAV_DEVIS',
				children: [
					{
						route: { name: 'devis' },
						title: 'Liste des devis',
						icon: 'mdi-clipboard-text-multiple',
						grant: 'API_GET_DEVIS',
					},
					{
						title: 'Créer un devis',
						icon: 'mdi-clipboard-plus',
						grant: 'API_POST_DEVIS',
						clickparameter: 'Devis',
					},
				]
			},
			{
				title: 'Projets',
				icon: 'mdi-folder-multiple',
				grant: 'NAV_PROJET',
				children: [
					{
						route: { name: 'projets' },
						title: 'Liste des projets',
						icon: 'mdi-folder-multiple',
						grant: 'API_GET_PROJET',
					},
					{
						title: 'Créer un projet',
						icon: 'mdi-folder-plus',
						grant: 'API_POST_PROJET',
						clickparameter: 'Projet',
					},
					{ divider: true, inset: true },
					{
						title: 'Créer une tache',
						icon: 'mdi-text-box-plus',
						grant: 'API_POST_TACHE',
						clickparameter: 'Tache',
					},
				]
			},
			{
				route: { name: 'temps' },
				title: 'Imputations',
				icon: 'mdi-clock-time-four',
				grant: 'API_GET_TEMPS',
			},
			{
				title: 'Paramétrage',
				icon: 'mdi-cog',
				grant: 'NAV_PARAMETRES',
				children: [
					{
						route: { name: 'option' },
						title: 'Options',
						icon: 'mdi-code-braces',
						grant: 'API_GET_OPTION',
					},
					{
						route: { name: 'organisation' },
						title: 'Organisation',
						icon: 'mdi-account-group',
						grant: 'API_GET_USER',
					},
					{
						route: { name: 'tva' },
						title: 'Tva',
						icon: 'mdi-currency-eur',
						grant: 'API_GET_TVA',
					},
					{
						route: { name: 'user' },
						title: 'Liste des utilisateurs',
						icon: 'mdi-account',
						grant: 'API_GET_USER',
					},
					/*{
						route: { name: 'token' },
						title: 'API Tokens',
						icon: 'mdi-key-variant',
					},*/
				]
			},
		];

		private onOpen() {
			this.open = true;
			this.reduce = false;
		}

		private onReduce() {
			if (this.open) {
				this.open = false;
			} else {
				this.reduce = true;
			}
		}

		private editTache: Tache = null;
		private editProjet: Projet = null;
		private editClient: Client = null;
		private editDevis: Devis = null;

		@Emit()
		private onCreate($parameter): void {
			switch ($parameter) {
  				case 'Tache':
					this.editTache = new Tache();
    			break;
  				case 'Projet':
					this.editProjet = new Projet();
    			break;
  				case 'Client':
					this.editClient = new Client();
    			break;
  				case 'Devis':
					this.editDevis = new Devis();
    			break;
			}
		}

	}
